const chat = {
  // Widget
  title: 'Support Chat',
  subtitle: 'How can we help you today?',
  placeholder: 'Type your message...',
  send: 'Send',
  close: 'Close chat',
  minimize: 'Minimize',
  expand: 'Expand chat',
  openChat: 'Open support chat',
  powered: 'Powered by AI',
  comingSoon: 'Coming soon',

  // Status
  online: 'Online',
  offline: 'Offline',
  typing: 'Typing...',
  thinking: 'Thinking...',
  connecting: 'Connecting...',

  // Messages
  welcome: 'Hello! I\'m your virtual assistant at Safaqat 24. How can I help you today?',
  welcomeOptions: 'You can ask me about:',
  errorMessage: 'Sorry, something went wrong. Please try again.',
  emptyMessage: 'Please type a message',
  connectionError: 'Connection error. Please check your internet connection.',

  // Quick actions
  quickActions: {
    title: 'Quick Actions',
    searchProperties: 'Search Properties',
    viewListings: 'View Listings',
    bookConsultation: 'Book Consultation',
    contactUs: 'Contact Us',
    pricing: 'Pricing & Membership',
    help: 'Need Help?',
  },

  // Topics
  topics: {
    properties: 'Properties & Listings',
    pricing: 'Pricing Information',
    consultation: 'Booking Consultation',
    account: 'Account & Profile',
    general: 'General Questions',
  },

  // AI Responses
  ai: {
    greeting: 'Welcome to Safaqat 24! I\'m here to help you find your perfect property.',
    searchHelp: 'I can help you search for properties. Tell me what you\'re looking for - location, price range, number of bedrooms, or any specific features.',
    propertyTypes: 'We have various property types including apartments, villas, studios, and penthouses. What type interests you?',
    priceHelp: 'Our properties range from budget-friendly to luxury options. What\'s your preferred price range?',
    locationHelp: 'We have properties in major Saudi cities including Riyadh, Jeddah, Dammam, and more. Which area are you interested in?',
    consultationHelp: 'You can book a free consultation with our real estate experts. Would you like me to guide you to the booking page?',
    contactHelp: 'You can reach our team via email at info@safaqat24.sa or call +966 50 560 8271.',
    membershipHelp: 'We offer various membership plans with exclusive benefits. Would you like to learn more?',
    notUnderstood: 'I\'m not sure I understood that. Could you please rephrase your question? You can ask about properties, pricing, consultations, or general inquiries.',
    thankYou: 'Thank you for reaching out! Is there anything else I can help you with?',
    goodbye: 'Thank you for chatting with us. Have a great day!',
  },

  // Suggestions
  suggestions: {
    title: 'Suggested Questions',
    searchProperty: 'How do I search for a property?',
    listProperty: 'How do I list my property?',
    consultation: 'How do I book a consultation?',
    membership: 'What membership plans do you offer?',
    contact: 'How can I contact support?',
    pricing: 'What are the rental prices?',
  },

  // Feedback
  feedback: {
    helpful: 'Was this helpful?',
    yes: 'Yes',
    no: 'No',
    thanks: 'Thanks for your feedback!',
  },

  // Time
  time: {
    justNow: 'Just now',
    minutesAgo: '{{count}} minute ago',
    minutesAgo_plural: '{{count}} minutes ago',
    hoursAgo: '{{count}} hour ago',
    hoursAgo_plural: '{{count}} hours ago',
    today: 'Today',
    yesterday: 'Yesterday',
  },
};

export default chat;
